import { AiOutlineWarning } from "react-icons/ai";
import { RiCheckLine } from "react-icons/ri";
import { IoEye } from "react-icons/io5";
import { useBaixarChecklist } from "services/api/AppWeb_Oportunidade/put-baixar-checklist";
import MaterialUI from "material-UI";

import * as S from "./styles";

interface Data {
  titulo: string;
  observacao: string;
  nome: string;
  url: string;
  extensao: string;
  codigoEtapa: string;
  dataDetalheOportunidade: any;
  refetchDetalheOportunidade: () => void;
  refetchHistorico: () => void;
}

export const ContainerChecklist = (data: Data) => {
  const viewChecklist = () => {
    window.open(data.url, "_blank");
  };

  const { mutate: mutateBaixarChecklist, isLoading: isLoadingChecklist } =
    useBaixarChecklist();

  const handleBaixarChecklist = () => {
    mutateBaixarChecklist(
      {
        idOportunidade: data?.dataDetalheOportunidade?.idOportunidade,
        codigoEtapa: data?.codigoEtapa,
      },
      {
        onSuccess: () => {
          data?.refetchDetalheOportunidade();
          data?.refetchHistorico();
        },
      }
    );
  };

  return (
    <S.Container backgroundColor="#ED6C0233" border="1px solid #F4A767">
      <S.Row>
        <S.Title color="#ED6C02">{data?.titulo}</S.Title>
      </S.Row>
      <S.SpaceY space={16} />
      <S.Row style={{ justifyContent: "space-between" }}>
        <div
          style={{
            display: "flex",
            gap: "8px",
          }}
        >
          <S.InfoChecklist>
            <AiOutlineWarning size={18} color="#ED6C02" />
            <S.SpaceX space={16} />
            <S.TitleChecklist>{data.nome}</S.TitleChecklist>
          </S.InfoChecklist>
          <S.WhiteButton onClick={viewChecklist}>
            <IoEye size={22} color="#2D5BFF" />
          </S.WhiteButton>
        </div>
        <S.Button
          width="164px"
          height="37px"
          disabled={isLoadingChecklist}
          onClick={handleBaixarChecklist}
        >
          <S.TitleButtonChecklist>
            {isLoadingChecklist ? (
              <MaterialUI.CircularProgress
                size={22}
                style={{ color: "#ffffff" }}
              />
            ) : (
              "Baixar Checklist"
            )}
          </S.TitleButtonChecklist>
          <RiCheckLine size={16} color="#ffff" />
        </S.Button>
      </S.Row>
      <S.SpaceY space={16} />
      <S.Row>
        <S.TextDescription color="#ED6C02">{data.observacao}</S.TextDescription>
      </S.Row>
    </S.Container>
  );
};
